var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "referrals" },
    [
      _c("m-converted-bonuses", {
        attrs: {
          active: _vm.isShowConvertedBonusesModal,
          "count-bonuses-current": _vm.bonusesCountLocal,
          "bonuses-rate": _vm.bonusesRateLocal,
        },
        on: {
          close: function ($event) {
            _vm.isShowConvertedBonusesModal = false
          },
          convertBonusesToRub: _vm.convertBonusesToRub,
        },
      }),
      _c("m-link-to-fill-questionnaire", {
        attrs: { active: _vm.isShowLinkToQuestionnaireModal },
        on: {
          close: function ($event) {
            _vm.isShowLinkToQuestionnaireModal = false
          },
        },
      }),
      _c("m-brought-by-employee", {
        attrs: {
          active: _vm.isShowBroughtByEmployeeModal,
          "current-brought-employee": _vm.referralEmployeeNameLocal,
        },
        on: {
          saveBroughtEmployee: _vm.saveBroughtEmployee,
          close: function ($event) {
            _vm.isShowBroughtByEmployeeModal = false
          },
        },
      }),
      !_vm.isDataLoading
        ? _c(
            "div",
            { staticClass: "referrals-header" },
            [
              _c(
                "div",
                { staticClass: "referrals-header-bonuses" },
                [
                  _c("div", { staticClass: "referrals-header-bonuses-count" }, [
                    _vm._v(_vm._s(_vm.bonusesCountLocal)),
                  ]),
                  _c("div", { staticClass: "referrals-header-bonuses-text" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.declOfNum(_vm.bonusesCountLocal, [
                            "бонус",
                            "бонуса",
                            "бонусов",
                          ])
                        ) +
                        " "
                    ),
                  ]),
                  _vm.userHavePermissionConvertBonusesAndChangeInvitedWorker()
                    ? _c("c-button", {
                        staticClass: "referrals-header-bonuses-convert",
                        attrs: {
                          disabled: _vm.bonusesCountLocal === 0,
                          label: "Конвертировать",
                        },
                        on: {
                          click: function ($event) {
                            _vm.isShowConvertedBonusesModal = true
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "referrals-header-referral",
                  class: {
                    "referrals-header-referral-empty":
                      !_vm.referralEmployeeNameLocal,
                  },
                },
                [
                  _c("div", { staticClass: "referrals-header-referral-text" }, [
                    _vm._v("Приведен сотрудником"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "referrals-header-referral-employee" },
                    [
                      _vm.referralEmployeeNameLocal !== null
                        ? _c(
                            "router-link",
                            {
                              staticClass:
                                "referrals-header-referral-employee-name",
                              attrs: {
                                to: {
                                  name: "personal-employee-referrals",
                                  params: {
                                    id: _vm.referralEmployeeNameLocal.value,
                                  },
                                },
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.referralEmployeeNameLocal.label) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.userHavePermissionConvertBonusesAndChangeInvitedWorker()
                        ? _c("c-button", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.html",
                                value: {
                                  container: "#app",
                                  trigger: "hover blur",
                                  content: "Редактировать",
                                  placement: "top",
                                },
                                expression:
                                  "{ container: '#app', trigger: 'hover blur', content: 'Редактировать', placement: 'top' }",
                                modifiers: { html: true },
                              },
                            ],
                            staticClass:
                              "referrals-header-referral-employee-edit",
                            class: {
                              "referrals-header-referral-employee-edit-empty":
                                !_vm.referralEmployeeNameLocal,
                            },
                            attrs: { size: "iconic", icon: "edit" },
                            on: {
                              click: function ($event) {
                                _vm.isShowBroughtByEmployeeModal = true
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c("c-button", {
                staticClass: "referrals-header-link-to-questionnaire",
                attrs: {
                  icon: "link",
                  size: "small",
                  label: "Ссылка на заполнение анкеты",
                },
                on: {
                  click: function ($event) {
                    _vm.isShowLinkToQuestionnaireModal = true
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.isDataLoading && _vm.tableDataBroughtEmployees.records.length === 0
        ? _c("div", { staticClass: "referrals-description" }, [
            _vm._m(0),
            _c("p", { staticClass: "referrals-description-text" }, [
              _vm._v(
                " За каждого приведенного кандидата и за каждое достижение приведенного сотрудника вам будут начисляться бонусы, которые затем можно конвертировать в " +
                  _vm._s(_vm.currencyLabel) +
                  " и перевести на "
              ),
              _c("b", [_vm._v("личный счёт.")]),
            ]),
          ])
        : _vm._e(),
      !_vm.isDataLoading && _vm.tableDataBroughtEmployees.records.length > 0
        ? _c(
            "div",
            { staticClass: "referrals-brought-employees" },
            [
              _c("div", { staticClass: "referrals-brought-employees-title" }, [
                _vm._v("Приведенные сотрудники"),
              ]),
              _c("c-data-table-personal-employee", {
                ref: "table",
                staticClass: "referrals-brought-employees-table",
                attrs: {
                  id: "broughtEmployees",
                  "empty-records-label": "Записи не найдены",
                  levels: 1,
                  "disabled-columns": [],
                  data: _vm.tableDataBroughtEmployees,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.isDataLoading && _vm.tableDataBroughtEmployees.records.length > 0
        ? _c(
            "div",
            { staticClass: "referrals-bonuses" },
            [
              _c("div", { staticClass: "referrals-bonuses-title" }, [
                _vm._v("Бонусы"),
              ]),
              _c(
                "div",
                { staticClass: "referrals-bonuses-filters" },
                [
                  _c("c-input", {
                    ref: "referralsBonusesPeriod",
                    staticClass: "referrals-bonuses-filters-period",
                    class: {
                      "referrals-bonuses-filters-period-disabled":
                        _vm.periodStart.length === 0 &&
                        _vm.periodEnd.length === 0 &&
                        _vm.tableDataHistoryBonuses.records.length === 0,
                    },
                    attrs: {
                      label: "За период",
                      placeholder: "00.00.0000 - 00.00.0000",
                      type: "period",
                      icon: "calendar",
                      clearable: true,
                      "icon-right": true,
                    },
                    model: {
                      value: _vm.periodLocal,
                      callback: function ($$v) {
                        _vm.periodLocal = $$v
                      },
                      expression: "periodLocal",
                    },
                  }),
                  _c("c-button", {
                    staticClass: "referrals-bonuses-filters-apply",
                    attrs: {
                      disabled:
                        _vm.periodStart.length === 0 &&
                        _vm.periodEnd.length === 0 &&
                        _vm.tableDataHistoryBonuses.records.length === 0,
                      label: "Применить",
                      color: "primary",
                    },
                    on: { click: _vm.applyFilters },
                  }),
                ],
                1
              ),
              _vm.tableDataHistoryBonuses.columns.length > 0
                ? _c("c-data-table-personal-employee", {
                    ref: "table",
                    staticClass: "referrals-bonuses-table",
                    attrs: {
                      id: "historyBonuses",
                      "empty-records-label": "Бонусов пока не начислено",
                      levels: 1,
                      "disabled-columns": [],
                      data: _vm.tableDataHistoryBonuses,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.isDataLoading
        ? _c("c-loader", {
            staticClass: "referrals-loader",
            attrs: {
              label: "Данные загружаются",
              active: _vm.isDataLoading,
              height: "500",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "referrals-description-text" }, [
      _vm._v(
        " Для того чтобы привести своего друга в компанию, нужно отправить ему вашу уникальную ссылку на заполнение анкеты. Чтобы её скопировать, кликните по кнопке "
      ),
      _c("b", [_vm._v("«Ссылка на заполнение анкеты».")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }